// Map of topics to their corresponding YouTube video URLs
export const topicVideos = {
    'Numbers and Fractions (Nọ́ḿbà àti Ìdá)': 'https://www.youtube.com/embed/bxTPJI-0XnM',
    'Markets and Haggling (Ọjà àti Níná Ọjà)': 'https://www.youtube.com/embed/s2J5j1q5evQ',
    'Money and the Economy (Owó àti Ètò ọrọ̀-ajé)': 'https://www.youtube.com/embed/ABoYGk7QHTg',
    'Travel (Ìrìnàjò)': 'https://www.youtube.com/embed/bxTPJI-0XnM',
    'Healthcare (Ètò Ìlera)': 'https://www.youtube.com/embed/8fpMROOF5c0',
    'Food (Oúnjẹ)': 'https://www.youtube.com/embed/uK2mR-bQB9I',
    'Education and School (Ẹ̀kọ́ àti Ilé-ìwé)': 'https://www.youtube.com/embed/FDIKfj-9j_s',
}; 